import type { JSX, PropsWithChildren } from 'react';

import { useLoadGooglePlaces } from '../hooks/useLoadGooglePlaces';

import { GooglePlacesContextProvider } from './context';

export function GooglePlacesProvider({ children }: PropsWithChildren<EmptyProps>): JSX.Element {
	const { status, autocompleteService, placesService } = useLoadGooglePlaces();

	return (
		<GooglePlacesContextProvider
			status={status}
			autocompleteService={autocompleteService}
			placesService={placesService}
		>
			{children}
		</GooglePlacesContextProvider>
	);
}
